export default class MarkerComment {
    createdBy = null;
    createdOn = null;
    comment = null;
    id = null;
    markerId = null;
    assetId = null;
    thumbnailPath = null;

    constructor(comment){
        this.id = comment.id;
        this.comment = comment.comment;
        this.assetId = comment.assetId;
        this.markerId = comment.markerId;
        this.createdOn = comment.createdOn;
        this.createdBy = comment.createdBy;
        this.thumbnailPath = comment.thumbnailPath;
    }
}